/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_viewer = {
    readonly isShopByRoomEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespFollowSearchBanner_viewer" | "SbSharedNullSearchRelatedItems_viewer">;
    readonly " $refType": "SbRespNullSearchResults_viewer";
};
export type SbRespNullSearchResults_viewer$data = SbRespNullSearchResults_viewer;
export type SbRespNullSearchResults_viewer$key = {
    readonly " $data"?: SbRespNullSearchResults_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespNullSearchResults_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isShopByRoomEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SHOP_BY_ROOM"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItems_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '7f4fb3c86242833cad0a4dc5d93852d8';
export default node;
